import { PublicClientApplication } from '@azure/msal-browser';

export const scopes = [import.meta.env.VITE_AZURE_API_SCOPE];

export const publicClientApplication = new PublicClientApplication({
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: `/redirect`,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
});
